/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Audio_Description_AriaInputs */



/**
* | output |
* | --- |
* | "Export audio description with synthetic voice" |
*
* @param {File_Export_Audio_Description_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_audio_description_aria = /** @type {((inputs?: File_Export_Audio_Description_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Audio_Description_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter la description audio avec voix synthetique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Exportieren Sie die Audiobeschreibung mit synthetischer Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta descrizione audio con voce sintetica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудиоописания с синтезированным голосом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportar audiodescripción con voz sintética")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出带有合成语音的音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("合成音声による音声解説をエクスポートする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृत्रिम आवाज के साथ ऑडियो विवरण निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar audiodescrição com voz sintética")
	return /** @type {LocalizedString} */ ("Export audio description with synthetic voice")
});